"use client";

import { useEffect } from "react";
import { useSession, signOut } from "next-auth/react";

export function AuthWatcher({ children }: { children: React.ReactNode }) {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status !== "authenticated") return;

    const shouldLogout = session?.error === "RefreshAccessTokenError" || session?.error === "MeSyncError" || session?.user?.logOut;

    if (shouldLogout) {
      console.log("🚪 Sessão inválida, deslogando usuário...");
      signOut({ callbackUrl: "/login" });
    }
  }, [status, session]);

  return <>{children}</>;
}
